export * from './IconAlignCenter';
